var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "hamburger_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.807 9.094v3.02h50.386V6.075H6.807zm0 22.906v2.989h50.386V29.01H6.807zm0 22.905v3.02h50.386v-6.039H6.807z",
    clipRule: "evenodd"
  })));
};
export { SvgHamburger as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuODA3IDkuMDk0NDVWMTIuMTE0SDMySDU3LjE5M1Y5LjA5NDQ1VjYuMDc0OTVIMzJINi44MDdWOS4wOTQ0NVpNNi44MDcgMzJWMzQuOTg4OUgzMkg1Ny4xOTNWMzJWMjkuMDExSDMySDYuODA3VjMyWk02LjgwNyA1NC45MDU0VjU3LjkyNDlIMzJINTcuMTkzVjU0LjkwNTRWNTEuODg2SDMySDYuODA3VjU0LjkwNTRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";